// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"301":"t__plugin-layout__Layout","501":"p__Search__index"}[chunkId] + "." + {"301":"be2efd89","501":"9925bc3b"}[chunkId] + ".chunk.css";
};